import type { HeaderBaseProps } from "../factory-header.types"
import { SiteHeader } from "../site-header"
import { QuestionarioHeaderCloseButton } from "./questionatio-header.close-btn"

export function SisalQuestionarioHeader({ homePageLogoLink }: HeaderBaseProps) {
  return (
    <SiteHeader>
      {homePageLogoLink}
      <QuestionarioHeaderCloseButton />
    </SiteHeader>
  )
}
